import { API_CONFIG } from '@/lib/api/config';
import { ApiError } from '@/lib/api/client';

const getAuthHeaders = () => ({
  'Content-Type': 'application/json',
  'Authorization': `Bearer ${localStorage.getItem('auth_token')}`,
});

export interface NotificationPreferences {
  messages_enabled: boolean;
  campaigns_enabled: boolean;
  templates_enabled: boolean;
  contact_import_enabled: boolean;
  team_invitations_enabled: boolean;
  business_account_enabled: boolean;
  system_enabled: boolean;
  quiet_hours_enabled: boolean;
  quiet_hours_start: string | null;
  quiet_hours_end: string | null;
  quiet_hours_timezone: string;
}

export const pushNotificationsApi = {
  async getPreferences(): Promise<NotificationPreferences> {
    const res = await fetch(`${API_CONFIG.BASE_URL}/notifications/preferences`, {
      headers: getAuthHeaders(),
    });
    const json = await res.json().catch(() => ({}));
    if (!res.ok) {
      throw ApiError.fromResult({ ...json, statusCode: res.status }, 'Failed to fetch notification preferences');
    }
    return json.data as NotificationPreferences;
  },

  async updatePreferences(prefs: Partial<NotificationPreferences>): Promise<NotificationPreferences> {
    const res = await fetch(`${API_CONFIG.BASE_URL}/notifications/preferences`, {
      method: 'PUT',
      headers: getAuthHeaders(),
      body: JSON.stringify(prefs),
    });
    const json = await res.json().catch(() => ({}));
    if (!res.ok) {
      throw ApiError.fromResult({ ...json, statusCode: res.status }, 'Failed to update notification preferences');
    }
    return json.data as NotificationPreferences;
  },

  async registerDevice(token: string, deviceType: 'android' | 'ios' | 'web') {
    const res = await fetch(`${API_CONFIG.BASE_URL}/notifications/push/register`, {
      method: 'POST',
      headers: getAuthHeaders(),
      body: JSON.stringify({ token, device_type: deviceType }),
    });
    const json = await res.json().catch(() => ({}));
    if (!res.ok) {
      throw ApiError.fromResult({ ...json, statusCode: res.status }, 'Failed to register device for push notifications');
    }
    return json;
  },

  async sendTestNotification() {
    const res = await fetch(`${API_CONFIG.BASE_URL}/notifications/push/test`, {
      method: 'POST',
      headers: getAuthHeaders(),
    });
    const json = await res.json().catch(() => ({}));
    if (!res.ok) {
      throw ApiError.fromResult({ ...json, statusCode: res.status }, 'Failed to send test notification');
    }
    return json;
  },

  async unregisterDevice(token: string) {
    const res = await fetch(`${API_CONFIG.BASE_URL}/notifications/push/unregister`, {
      method: 'POST',
      headers: getAuthHeaders(),
      body: JSON.stringify({ token }),
    });
    const json = await res.json().catch(() => ({}));
    if (!res.ok) {
      throw ApiError.fromResult({ ...json, statusCode: res.status }, 'Failed to unregister device');
    }
    return json;
  },
};
